import { Box, Flex, Heading, Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  dashboardRoutePadding,
  errorToastConfig,
} from '../../packages/common-frontend/constants';
import { useCreditFacilityContext } from '../../packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditFacilitySelect } from '../../packages/credit-facility/ui/CreditFacilitySelect';
import { UndoPipelineRunView } from '../../packages/undoPipelineRun/UndoPipelineRunView';

export const UndoPipelineRunRoute = () => {
  const toast = useToast();

  const { data: userData, loading: userLoading } = useGetUserQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
  });
  const { creditFacilityId } = useCreditFacilityContext();

  if (userLoading || !userData) {
    return <Skeleton data-testid="loading-reports-view" height="600px" />;
  }

  const { user } = userData;

  return (
    <Box padding={dashboardRoutePadding}>
      <Flex justify="space-between" mb="20px">
        <Heading>Undo Pipeline Run</Heading>
        <Box>
          <CreditFacilitySelect organizationId={user?.organizationId} />
        </Box>
      </Flex>
      <UndoPipelineRunView creditFacilityId={creditFacilityId} />
    </Box>
  );
};
